import { useState, useMemo, useEffect } from "react";

export default function useSearchableTable(
  data = [],
  externalSearchText,
  onSearchTextChange
) {
  const isControlled =
    externalSearchText !== undefined && externalSearchText !== null;
  const [internalSearch, setInternalSearch] = useState(
    isControlled ? externalSearchText : ""
  );

  useEffect(() => {
    if (isControlled) {
      setInternalSearch(externalSearchText);
    }
  }, [isControlled, externalSearchText]);

  const searchText = isControlled ? externalSearchText : internalSearch;
  const setSearchText = (val) => {
    if (isControlled && onSearchTextChange) {
      onSearchTextChange(val);
    } else {
      setInternalSearch(val);
    }
  };

  const filteredData = useMemo(() => {
    if (!data?.length) return [];
    if (!searchText) return data;

    return data.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [data, searchText]);

  return {
    searchText,
    setSearchText,
    filteredData,
  };
}
